import React, {useState, useEffect } from 'react';
import specialization from '../data/specialization.json';
import benefits from '../data/benefits.json';

import { getKindergartensList } from '../../../kindergartens/list/actions';

import { formatAddress } from '../helpers/address';

const SELECTED_KG_PERM = 'cabinetkgselected';


const typeDocs = [
    { "name": "Довідка", "value": "1" },
    { "name": "Висновок", "value": "2" },
    { "name": "Направлення", "value": "3"}
];




const getPMInfo = ()=> {
    const sel_pm_info = localStorage.getItem(SELECTED_KG_PERM);
    return sel_pm_info && JSON.parse(sel_pm_info) || [];
}


const Step6 = ({ formData, errors, onChange, isPreview = false }) => {


  const [kg_info, setKGInfo] = useState(getPMInfo());

  useEffect(()=>{

    async function api(needInfoKgId, existInfoKg) {

      if(needInfoKgId.length < 1) return setKGInfo(existInfoKg);

      const result = await getKindergartensList({filters: { 'id_kg': needInfoKgId }});
      
      const resArr = [...existInfoKg, ...result]; ; 
      
      setKGInfo(resArr)
    };

    const neededKgDesc = formData.selectedSchools;

    const localInfoKgs = getPMInfo();

    const localIdArr = localInfoKgs.map(r=>r._id);

    const leftKgs = neededKgDesc.filter(n=>!localIdArr.includes(n));

    api(leftKgs, localInfoKgs);

  }, [formData.selectedSchools]);

  useEffect(()=>{if(errors.agreePersonalData) alert(errors.agreePersonalData)},[errors.agreePersonalData]);

  const getGenderName = (gender) => {
    return gender === 'girl' ? 'Дівчинка' : 'Хлопчик';
  };

  const getCountryName = (country) => {
    return country === 'ua' ? 'Україна' : 'Іноземна держава';
  };

  const formatDate = (ISODate) => new Date(ISODate).toLocaleDateString('uk');

  const getSelectedSchools = (kgl) => kg_info.filter(t => kgl.includes(t._id)).map(kg => ([kg.number, kg.name].join(" ")));

  

  // Функція для відображення інформації про документи
  const renderDocumentInfo = (document, prefix = '') => (
    <>
      <div className="review-row">
        <span className="review-label">{prefix}Тип документа:</span>
        <span className="review-value">{document.type || 'Не вказано'}</span>
      </div>
      <div className="review-row">
        <span className="review-label">{prefix}Номер документа:</span>
        <span className="review-value">{document.number || 'Не вказано'}</span>
      </div>
      <div className="review-row">
        <span className="review-label">{prefix}Кому видано:</span>
        <span className="review-value">{document.issuedTo || 'Не вказано'}</span>
      </div>
      <div className="review-row">
        <span className="review-label">{prefix}Дата видачі:</span>
        <span className="review-value">{document.issueDate ? formatDate(document.issueDate) : 'Не вказано'}</span>
      </div>
    </>
  );

  return (
    <div className="form-section form-section--wide">
      {!isPreview && <>
          <h2  className="form-section-title">Погодження з умовами</h2>

          {/* Соглашение */}
          <div className="mt-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="agreePersonalData"
                checked={formData.agreePersonalData == "yes"}
                onChange={(e) => onChange('agreePersonalData', formData.agreePersonalData == "yes" ? "no" : "yes")}
              />
              <label className="form-check-label" htmlFor="agreePersonalData">
                Погоджуюсь на оброблення персональних даних
              </label>
            </div>
            {errors.agreePersonalData && <div style={{ paddingLeft: '32px'}} className="invalid-feedback">{errors.agreePersonalData}</div>}
          </div>

          <div className="mt-3 alert alert-info">
            <strong>Увага!</strong> Будь ласка, уважно перевірте всі введені дані перед відправкою заявки.
          </div>

      </>}

      <div className="review-section">
        {/* Дані дитини */}
        <div className="review-block">
          <h3 className="review-title">Дані дитини</h3>
          <div className="review-content">
            <div className="review-row">
              <span className="review-label">ПІБ дитини:</span>
              <span className="review-value">
                {formData.child.lastName} {formData.child.firstName} {formData.child.middleName}
              </span>
            </div>
            <div className="review-row">
              <span className="review-label">Дата народження:</span>
              <span className="review-value">{formatDate(formData.child.birthDate)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Стать:</span>
              <span className="review-value">{getGenderName(formData.child.gender)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Свідоцтво про народження:</span>
              <span className="review-value">{formData.child.birthCertificate.seriesNumber || 'Не вказано'}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Дата видачі свідоцтва:</span>
              <span className="review-value">{formatDate(formData.child.birthCertificate.issueDate)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Країна видачі:</span>
              <span className="review-value">{getCountryName(formData.child.birthCertificate.country)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Зареєстрована адреса проживання:</span>
              <span className="review-value">{formatAddress(formData.child.address, formData.dictionary.addresses)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Фактична адреса проживання:</span>
              <span className="review-value">
                {formData.child.sameFactAddress == "yes" ? 
                  'Співпадає з зареєстрованою' : 
                  formatAddress(formData.child.addressFact, formData.dictionary.addresses)}
              </span>
            </div>
          </div>
        </div>

        {/* Дані заявника */}
        <div className="review-block">
          <h3 className="review-title">Дані заявника</h3>
          <div className="review-content">
            <div className="review-row">
              <span className="review-label">ПІБ заявника:</span>
              <span className="review-value">
                {formData.applicant.lastName} {formData.applicant.firstName} {formData.applicant.middleName}
              </span>
            </div>
            <div className="review-row">
              <span className="review-label">Громадянство:</span>
              <span className="review-value">{formData.applicant.citizenship}</span>
            </div>
            <div className="review-row">
              <span className="review-label">РНОКПП:</span>
              <span className="review-value">
                {formData.applicant.hasRnokpp === 'no' ? 
                  'Відсутній (релігійні переконання)' : 
                  formData.applicant.rnokpp || 'Не вказано'}
              </span>
            </div>
            
            {/* Документ, що посвідчує особу (якщо немає РНОКПП) */}
            {formData.applicant.hasRnokpp === 'no' && (
              <>
                <div className="review-row">
                  <span className="review-label">Вид документу:</span>
                  <span className="review-value">
                    {formData.applicant.documentType === 'passport' ? 
                      'паспорт' : 
                      formData.applicant.documentType === 'idCard' ? 
                      'ID картка' : 'Не вказано'}
                  </span>
                </div>
                <div className="review-row">
                  <span className="review-label">Реквізити документу:</span>
                  <span className="review-value">{formData.applicant.documentDetails || 'Не вказано'}</span>
                </div>
              </>
            )}
            
            <div className="review-row">
              <span className="review-label">Телефон:</span>
              <span className="review-value">{formData.applicant.phone || 'Не вказано'}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Email:</span>
              <span className="review-value">{formData.applicant.email || 'Не вказано'}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Адреса:</span>
              <span className="review-value">{formatAddress(formData.applicant.address, formData.dictionary.addresses)}</span>
            </div>
          </div>
        </div>

        {/* Додаткові побажання */}
        <div className="review-block">
          <h3 className="review-title">Додаткові побажання</h3>
          <div className="review-content">
            <div className="review-row">
              <span className="review-label">Бажана дата вступу:</span>
              <span className="review-value">{formatDate(formData.preferences.desiredDate)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Бажаю відвідувати групу меншу за віком:</span>
              <span className="review-value">{formData.preferences.ageMenu ? 'Так' : 'Ні'}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Інклюзивна група:</span>
              <span className="review-value">{formData.preferences.inclusiveGroup ? 'Так' : 'Ні'}</span>
            </div>
            
            {formData.preferences.diseaseType && typeDocs.find(t=>t.value == formData.preferences.diseaseDocument.type) && (
              <>
                <div className="review-row">
                  <span className="review-label">Вид захворювання:</span>
                  <span className="review-value">
                    {specialization.find(s => s._id == formData.preferences.diseaseType)?.name || 'Не вказано'}
                  </span>
                </div>
                {renderDocumentInfo(Object.assign({}, formData.preferences.diseaseDocument, {type: typeDocs.find(t=>t.value == formData.preferences.diseaseDocument.type)["name"]}))}
              </>
            )}
          </div>
        </div>

        {/* Пільги */}
        {formData.benefits.type && (
          <div className="review-block">
            <h3 className="review-title">Пільги</h3>
            <div className="review-content">
              <div className="review-row">
                <span className="review-label">Вид пільги:</span>
                <span className="review-value">
                  {benefits.find(b => b._id == formData.benefits.type)?.name || 'Не вказано'}
                </span>
              </div>

              {/* Звичайні пільги (з документами) */}
              {formData.benefits.documentType && (
                renderDocumentInfo({type: formData.benefits.documentType, number: formData.benefits.documentNumber, issuedTo: formData.benefits.issuedTo, issueDate: formData.benefits.issueDate})
              )}

              {/* Територія обслуговування */}
              {formData.benefits.address && (
                <div className="review-row">
                  <span className="review-label">Адреса для пільги:</span>
                  <span className="review-value">{formatAddress(formData.benefits.address, formData.dictionary.addresses)}</span>
                </div>
              )}

              {/* Брати та сестри в одному ЗДО */}
              {formData.benefits.kindergarten && (
                <>
                  <div className="review-row">
                    <span className="review-label">Заклад дошкільної освіти:</span>
                    <span className="review-value">
                      {formData.benefits.kindergarten === 'sadok1' ? 'ДНЗ №1 "Сонечко"' :
                       formData.benefits.kindergarten === 'sadok2' ? 'ДНЗ №2 "Зірочка"' :
                       formData.benefits.kindergarten === 'sadok3' ? 'ДНЗ №3 "Чебурашка"' :
                       formData.benefits.kindergarten === 'sadok4' ? 'ДНЗ №4 "Казка"' :
                       'Не вказано'}
                    </span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Свідоцтво про народження дитини:</span>
                    <span className="review-value">{formData.benefits.siblingBirthCertificate || 'Не вказано'}</span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Ім'я дитини:</span>
                    <span className="review-value">{formData.benefits.siblingName || 'Не вказано'}</span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Дата народження дитини:</span>
                    <span className="review-value">
                      {formData.benefits.siblingBirthDate ? formatDate(formData.benefits.siblingBirthDate) : 'Не вказано'}
                    </span>
                  </div>
                </>
              )}

              {/* Діти працівників закладу */}
              {formData.benefits.employeeName && (
                <>
                  <div className="review-row">
                    <span className="review-label">Заклад дошкільної освіти:</span>
                    <span className="review-value">
                      {formData.benefits.kindergarten === 'sadok1' ? 'ДНЗ №1 "Сонечко"' :
                       formData.benefits.kindergarten === 'sadok2' ? 'ДНЗ №2 "Зірочка"' :
                       formData.benefits.kindergarten === 'sadok3' ? 'ДНЗ №3 "Чебурашка"' :
                       formData.benefits.kindergarten === 'sadok4' ? 'ДНЗ №4 "Казка"' :
                       'Не вказано'}
                    </span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Ім'я працівника:</span>
                    <span className="review-value">{formData.benefits.employeeName || 'Не вказано'}</span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">РНОКПП працівника:</span>
                    <span className="review-value">{formData.benefits.employeeRnokpp || 'Не вказано'}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Обрані садочки */}
        {formData.selectedSchools && formData.selectedSchools.length > 0 && (
          <div className="review-block">
            <h3 className="review-title">Обрані садочки</h3>
            <div className="review-content">
              {getSelectedSchools(formData.selectedSchools).map((school, index) => (
                <div key={index} className="review-row">
                  <span className="review-label">Садочок {index + 1}:</span>
                  <span className="review-value">{school}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Step6;